import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import { RichText } from '@redturtle/iovisit-theme/components/Views';
const Body = (props) => {
  const intl = useIntl();

  const program = props?.properties?.event_program_text;
  const event_program = RichText({
    content: program,
    title: intl.formatMessage(messages.event_program),
    titleTag: 'h3',
  });
  return (
    <div className={cx(`event-program-block-wrapper `)}>{event_program}</div>
  );
};

export default Body;

const messages = defineMessages({
  event_program: { id: 'event_program', defaultMessage: 'Programma' },
});
